import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TabsModule } from 'beyond-util';
import { PregledUgovoraZaObracunComponent } from './pregled-ugovora-za-obracun.component';

@NgModule({
  declarations: [PregledUgovoraZaObracunComponent],
  entryComponents: [PregledUgovoraZaObracunComponent],
  exports: [PregledUgovoraZaObracunComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class PregledUgovoraZaObracunModule {}



// WEBPACK FOOTER //
// ./src/app/pages/pregled-ugovora-za-obracun/pregled-ugovora-za-obracun.module.ts